import { render, staticRenderFns } from "./MainlandAccountOpen.vue?vue&type=template&id=77b06852&scoped=true&"
import script from "./MainlandAccountOpen.vue?vue&type=script&lang=ts&"
export * from "./MainlandAccountOpen.vue?vue&type=script&lang=ts&"
import style0 from "./MainlandAccountOpen.vue?vue&type=style&index=0&id=77b06852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b06852",
  null
  
)

export default component.exports